// @flow
import React, { Component } from 'react';
import { applyPermissionToLocationReduxState } from './index';

export default ComposedComponent => {
  const withCurrentLocation = class extends Component {
    componentDidMount = async () => {
      const { permission, setPermission } = this.props;
      if (permission === 'initneeded' && 'permissions' in navigator) {
        const result = await navigator.permissions.query({
          name: 'geolocation',
        });
        setPermission(result.state);
      } else {
        // Old Edge and Safari does not support `navigator.permissions`
        // but triggers a location permission dialog when
        // `navigator.geolocation.getCurrentPosition()` is invoked.
        //
        // Denial of permissions in these cases are handled below in the
        // `errorCallback` of `getCurrentPosition()`.
        setPermission('granted');
      }
    };

    goToCurrentLocation = () => {
      // eslint-disable-next-line react/prop-types
      const { permission, setFitBounds, setPermission } = this.props;
      const afterGetCurrentPosition = ({ coords: { latitude, longitude } }) => {
        if (permission !== 'granted') {
          setPermission('granted');
        }
        setFitBounds([longitude, latitude, longitude, latitude]);
      };
      if (permission === 'granted' || permission === 'prompt') {
        navigator.geolocation.getCurrentPosition(
          afterGetCurrentPosition,
          () => {
            setPermission('denied');
          }
        );
      }
    };

    render = () => {
      // eslint-disable-next-line react/prop-types
      const { setPermission, ...restProps } = this.props;
      return (
        <ComposedComponent
          {...restProps}
          goToCurrentLocation={this.goToCurrentLocation}
        />
      );
    };
  };
  return applyPermissionToLocationReduxState(withCurrentLocation);
};



// WEBPACK FOOTER //
// ./components/withCurrentLocation/withCurrentLocation.js